//@ts-check
import React from "react";

/**
 *
 * @param {{className?: string, scrollname: string, children: import('react').ReactNode}} props
 *
 */
const ScrollContent = (props) => {

    if (!props.scrollname) {
        throw new Error("no scroll name")
    }

    return (
    <div className={"scrollContent ul-fix scroller " + props.className} aria-live="polite">
            {props.children}
        </div>
    );
}


export default ScrollContent;